import React from 'react';

import sy from '~/styles';
import {Text} from '~/components/controls';
import PropTypes from 'prop-types';

const ExternalLink = ({href, target = '_blank', textStyle, children}) => {
  return (
    <a
      href={href}
      style={{textDecoration: 'none'}}
      target={target}
      rel="noreferrer">
      <Text style={[sy['underline'], textStyle]}>{children}</Text>
    </a>
  );
};
ExternalLink.propTypes = {
  href: PropTypes.any,
  target: PropTypes.any,
  textStyle: PropTypes.any,
  children: PropTypes.any,
};


export default ExternalLink;
